export const DEFAULT_QUOTE_VALIDITY = 60 * 30 // 30 min
